<template>
  <div :class="{ 'iframe-mode': isInIframe }">
    <v-alert
      class="w-11/12 md:w-full md:mt-4"
      :value="error.show"
      type="error"
      >{{ error.message }}</v-alert
    >
    <div class="flex flex-wrap items-center justify-center md:pt-16">
      <div class="w-4/5 md:w-full">
        <div
          class="font-medium text-center custom-color-neutral  md:mt-0 title-text"
        >
          <zt-icon name="calendar-2" class="mr-2 md:hidden" />
          <template v-if="tiposLic.selected && !loadingLicenseType">
            <span :class="primaryTextClass">{{ saldo }} </span>
            <span :class="primaryTextClass">{{
              getTranslatedDayText(saldo)
            }}</span>
            <!-- Botón de información para balance normal -->
            <span
              v-if="
                !sichernPeopleIntegration &&
                  state.config.showDetails &&
                  detailsBySubtype.length > 0 &&
                  state.config.pending == 0
              "
              @click="modalActive = true"
              :class="primaryTextClass"
            >
              <zt-icon name="info-circle-alt" />
            </span>
            <!-- Botón de información para Sichern People Integration -->
            <span
              class="cursor-pointer"
              :class="primaryTextClass"
              v-if="sichernPeopleDetailsData"
              @click="modalSichernPeopleInfo = true"
            >
              <zt-icon name="info-circle-alt" />
            </span>
          </template>
        </div>
        <div
          class="font-medium text-center custom-color-neutral mt-4 md:mt-2 mb-10 text-zt-lg"
        >
          <template v-if="tiposLic.selected && !loadingLicenseType">
            <template v-if="saldo > 1 || saldo == 0 || saldo < -1">
              <template v-if="state.config.showDetails == true">{{
                $t('message.licenseComponent.licenseBox.available')
              }}</template>
              <template v-else>{{
                $t('message.licenseComponent.licenseBox.registered')
              }}</template>
            </template>
            <template v-else-if="saldo == 1 || saldo == -1">
              <template v-if="state.config.showDetails == true">{{
                $t('message.licenseComponent.licenseBox.available1')
              }}</template>
              <template v-else>{{
                $t('message.licenseComponent.licenseBox.registered1')
              }}</template>
            </template>
          </template>
          <template v-else>{{
            $t('message.licenseComponent.licenseBox.selectLicenseType')
          }}</template>
        </div>
        <div
          v-if="previewDaysVP > 0"
          class="font-medium text-center custom-color-neutral md:mt-0 text-xl py-8 border-t border-gray-300 "
        >
          <span class="text-xl" :class="primaryTextClass">{{ previewDaysVP }} </span>
          <span class="text-xl" :class="primaryTextClass">{{
            getTranslatedDayText(previewDaysVP)
          }}</span>
          <div class="relative flex items-center justify-center mb-4 mt-2">
            <span class="text-base text-center custom-color-neutral">
              {{ $t('message.licenseComponent.licenseBox.toCreditLabel') }}
            </span>
            <div class="tooltip-container">
              <zt-icon
                name="info-circle-alt"
                class="cursor-pointer tooltip-trigger"
                :class="primaryTextClass"
              />
              <div class="tooltip-content">
                <div class="tooltip-arrow"></div>
                {{ $t('message.licenseComponent.licenseBox.tooltipToCredit') }}
              </div>
            </div>
          </div>
        </div>
        <div class="w-full">
          <v-select
            solo
            item-text="nombre"
            item-value="id"
            :items="tiposLic.list"
            :value="typeSelected.id"
            v-model="typeSelected.id"
            @change="selectType"
            data-vs-select="licenceType"
            :label="$t('message.licenseComponent.licenseBox.licenseTypeLabel')"
          ></v-select>
        </div>
        <template v-if="loadingLicenseType">
          <div class="mt-4 text-center">
            <vue-loading
              background-color="rgba(0,0,0,0.0)"
              :active="loadingLicenseType"
              color="#004250"
              :width="50"
              :height="50"
              :is-full-page="false"
            />
          </div>
        </template>
        <template v-else>
          <v-checkbox
            data-vs-check-box="allowsSalaryPaymentAdvance"
            v-model="salaryPaymentAdvance"
            :color="primaryColor"
            :label="
              $t(
                'message.licenseComponent.licenseBox.registerAnticipatePayment'
              )
            "
            @change="addSalaryPaymentAdvanceToRequest"
            :value="1"
            v-if="allowsSalaryPaymentAdvance"
          />
          <div
            class="flex justify-center "
            v-if="isChileanUserAndRequestHolidays"
          >
            <zt-check-box
              v-model="legales"
              class=" text-center custom-color-neutral text-lg"
              :color="primaryColor"
              zt-value='"1"'
              @change="addIdHolidayTypeToRequest()"
              >{{ $t('message.DocumentsComponents.legal') }}</zt-check-box
            >
            <zt-check-box
              v-model="progresivos"
              :color="primaryColor"
              class=" text-center custom-color-neutral text-lg"
              zt-value="3"
              @change="addIdHolidayTypeToRequest"
              >{{ $t('message.DocumentsComponents.progresive') }}</zt-check-box
            >
          </div>
          <div
            class="md:pt-4 text-center"
            v-if="config.puede_solicitar && !showInitError"
          >
            <zt-button
              @click="$emit('step-forward')"
              data-vs-button="stepforward"
              :disabled="disableNextButton"
              >{{
                initBtn
                  ? $t(
                      'message.licenseComponent.licenseBox.buttonSolicitudeLicenseDisabled'
                    )
                  : $t(
                      'message.licenseComponent.licenseBox.buttonSolicitudeLicense'
                    )
              }}</zt-button
            >
          </div>
          <div v-if="showInitError">
            <v-alert class="alertInitError" type="error" :value="true">{{
              $t('message.licenseComponent.licenseBox.initError')
            }}</v-alert>
          </div>
        </template>
      </div>
    </div>
    <zt-modal
      :active="modalActive"
      @close="modalActive = false"
      id="balanceDetails"
    >
      <template slot="modal-header">
        <div class="p-4 font-bold text-zt-lg">
          <span>{{
            $t('message.licenseComponent.licenseBox.balanceDetails')
          }}</span>
        </div>
      </template>
      <template v-for="(item, index) in detailsBySubtype">
        <zt-list-item
          class="zt-list-item px-4 text-black"
          :class="index == 0 ? 'pb-3' : 'py-3'"
          :key="index"
          title=""
          to="#"
        >
          <template slot="icon">
            <div class="w-full float-left">
              <span class="text-black text-zt-lg">{{ item.periodo }}</span>
              <div
                v-for="subtipo in item.subtipos"
                :key="subtipo.id"
                class="text-zt-dark-500"
              >
                <span> {{ subtipo.nombre }}: {{ trunc(subtipo.dias) }} </span>
                <!--  {{ $t("message.licenseComponent.licenseBox.days") }} -->
              </div>
            </div>
          </template>
        </zt-list-item>
        <hr
          :key="index"
          v-if="detailsBySubtype.length != index + 1"
          class="w-full"
          style="color: #969696;"
        />
      </template>
    </zt-modal>

    <zt-modal
      :active="modalSichernPeopleInfo"
      @close="modalSichernPeopleInfo = false"
      id="sichernPeopleInfo"
      max-width="80rem"
      :fullscreen="isMobile"
    >
      <template slot="modal-header">
        <div class="p-4 font-bold text-zt-lg">
          <span>{{
            $t('message.licenseComponent.licenseBox.sichernPeopleInfo')
          }}</span>
        </div>
      </template>
      <div class="px-4 pb-4">
        <div class="sichern-people-table">
          <div class="table-container">
            <HolidaysBalanceTable
              :saldo="saldo"
              :isChilean="isChileanUserAndRequestHolidays"
              :details="sichernPeopleDetailsData"
            />
          </div>
        </div>
      </div>
    </zt-modal>
  </div>
</template>

<script>
import Licenses from '@/apiClient/Licenses'
import trunc from '@/utils/trunc.js'
import SichernIntegration from '@/apiClient/SichernIntegration'
import HolidaysBalanceTable from './HolidaysBalanceTable.vue'

export default {
  inject: ['state', 'mutations'],
  components: {
    HolidaysBalanceTable
  },
  props: {
    tiposLic: {
      type: Object,
      default: {}
    },
    error: {
      type: Object,
      default: {
        show: false,
        message: ''
      }
    },
    initButton: {
      type: Boolean,
      default: true
    },
    showInitError: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      licenses: Licenses,
      config: {},
      loadingLicenseType: false,
      typeSelected: {
        id: '',
        name: ''
      },
      saldo: 0,
      detailsBySubtype: '',
      initBtn: this.initButton,
      modalActive: false,
      modalSichernPeopleInfo: false,
      sichernPeopleIntegration: false,
      previewDaysVP: 0,
      vpHolidayType: '',
      allowsSalaryPaymentAdvance: false,
      salaryPaymentAdvance: false,
      legales: false,
      progresivos: false,
      isChileanUserAndRequestHolidays: false,
      disableNextButton: false,
      isLatam: this.$store.state.user.pais === 'LA',
      hasChileanHolidayModelCache: null,
      isMobile: window.innerWidth <= 768,
      loading: false,
      headers: [
        {
          text: this.$t('message.licenseComponent.licenseBox.periodoLabel'),
          align: 'left',
          sortable: false,
          value: 'year',
          class: ['column-header']
        },
        {
          text: this.$t('message.licenseComponent.licenseBox.inicioLabel'),
          sortable: false,
          align: 'left',
          value: 'dateFrom',
          class: ['column-header']
        },

        {
          text: this.$t('message.licenseComponent.licenseBox.limiteLabel'),
          sortable: false,
          align: 'left',
          value: 'dateTo',
          class: ['column-header']
        },
        {
          text: this.$t('message.licenseComponent.licenseBox.disponiblesLabel'),
          sortable: false,
          align: 'left',
          value: 'days',
          class: ['column-header']
        },
        {
          text: this.$t('message.licenseComponent.licenseBox.vencenLabel'),
          sortable: false,
          align: 'left',
          value: 'expire',
          class: ['column-header']
        }
      ],
      sichernPeopleDetailsData: null
    }
  },
  created() {
    this.licenses = new Licenses()
    this.vi = new SichernIntegration()
  },
  computed: {
    isInIframe() {
      return this.$iframeMessages && this.$iframeMessages.isTokenValid()
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-100'
    },
    primaryColor() {
      return this.isInIframe ? '#2694fc' : 'primary'
    },
    idHolidayType() {
      return [this.legales, this.progresivos].filter(Boolean)
    }
  },

  methods: {
    trunc(days) {
      return trunc(days)
    },
    selectType() {
      this.loadingLicenseType = true
      this.isChileanUserAndRequestHolidays = false
      this.allowsSalaryPaymentAdvance = false
      let typeSelected = _.filter(this.tiposLic.list, type => {
        if (type.id === this.typeSelected.id) {
          return type
        }
      })
      this.typeSelected.name = typeSelected[0].nombre
      this.typeSelected.id_categoria_tipo_documento =
        typeSelected[0].id_categoria_tipo_documento
      this.$emit('set-typeselected-id', this.typeSelected.id)
      this.$emit('set-typeselected-name', this.typeSelected.name)

      if (
        this.typeSelected.id_categoria_tipo_documento &&
        this.typeSelected.id_categoria_tipo_documento !== '0'
      ) {
        this.licenses
          .getTypeDocumentTemplate(
            this.typeSelected.id_categoria_tipo_documento
          )
          .then(res => {
            const { data } = res.data

            if (data) {
              this.mutations.setUploadFilesMetaData(data)
              this.configUser()
            } else {
              this.initBtn = true
              this.error.show = true
              this.error.message = this.$t(
                `message.errorReference.${res.data.code}`
              )
              this.loadingLicenseType = false
            }
          })
          .catch(err => {
            let code = `err${err.response.status}`
            this.initBtn = true
            this.error.show = true
            this.error.message = this.$t(`message.errorReference.${code}`)
            this.loadingLicenseType = false
          })
      } else {
        if (this.state.uploadFilesMetaData) {
          this.mutations.cleanUploadFilesMetaData()
        }
        this.configUser()
      }
    },
    async configUser() {
      try {
        await this.$store.dispatch('setConfig')
        let config = { ...this.$store.getters.getConfig }
        this.error.show = false
        this.error.message = ''
        let configPorTipo = config.licencias_tipo
        let configTipo
        for (let [tipo] of Object.entries(configPorTipo)) {
          if (configPorTipo[tipo].id === parseInt(this.tiposLic.selected, 10)) {
            configTipo = configPorTipo[tipo]
            delete config.licencias_tipo
            break
          }
        }
        const needToUploadFiles =
          configTipo.upload_document &&
          !Number(this.typeSelected.id_categoria_tipo_documento)
        if (needToUploadFiles) {
          this.initBtn = true
          this.error.show = true
          this.error.message = this.$t(
            `message.licenseComponent.licenseBox.communicateWithSupport`
          )
          this.loadingLicenseType = false
        }
        this.config = Object.assign({}, config, configTipo)
        this.licenses
          .getBalanceByType(this.tiposLic.selected)
          .then(res => {
            this.config.showDetails = res.data.results.data[0].show_details
            this.config.positiveBalance =
              res.data.results.data[0].positive_balance
            this.saldo = trunc(res.data.results.data[0].available)
            //Bloqueo o muestro boton solicitar
            if (
              this.saldo > 0 ||
              this.config.negative_balance === true ||
              this.config.positiveBalance === true ||
              this.config.showDetails === false
            ) {
              this.initBtn = false
            } else {
              this.initBtn = true
            }

            this.config.canUploadFiles = configTipo.upload_document
            this.config.uploadFilesRequired =
              configTipo.upload_document_required
            this.checkSichernPeopleIntegration()
            this.mutations.setConfig(this.config)
            this.$emit('set-config')

            if ('details' in res.data.results.data[0]) {
              const details = res.data.results.data[0].details

              this.detailsBySubtype = _.chain(details)
                // Group the elements of Array based on `periodo` property
                .groupBy('periodo')
                // `key` is group's name (periodo), `value` is the array of objects
                .map((value, key) => ({ periodo: key, subtipos: value }))
                .value()
                .reverse()
            } else {
              this.detailsBySubtype = []
            }
            this.loadingLicenseType = false
          })
          .catch(err => {
            this.initBtn = true
            this.error.show = true
            this.error.message = this.$t(
              `message.errorReference.${err.response.data.response_v2.code}`
            )
            this.loadingLicenseType = false
          })
      } catch (error) {
        this.initBtn = true
        this.error.show = true
        this.error.message = this.$t(
          `message.errorReference.${error.response.data.response_v2.code}`
        )
        this.loadingLicenseType = false
      }
    },
    async checkSichernPeopleIntegration() {
      this.sichernPeopleDetailsData = null
      this.previewDaysVP = 0
      this.sichernPeopleIntegration = this.$store.state.hasIntegrationSichernPeople

      if (this.sichernPeopleIntegration) {
        this.disableNextButton = true
        const res = await this.vi.checkHalfDay(this.typeSelected.id)
        let hasChileanHolidayModel = false
        if (this.isLatam) {
          if (this.hasChileanHolidayModelCache === null) {
            const hasChileanHolidayModelResponse = await this.vi.hasChileanHolidayModel()
            this.hasChileanHolidayModelCache =
              hasChileanHolidayModelResponse.data.hasChileanHolidayModel
          }
          hasChileanHolidayModel = this.hasChileanHolidayModelCache
        }
        this.config.medio_dia = res.data.data['partialAbsence']
        this.checkAllowsSalaryPaymentAdvance(res.data.data)
        this.vpHolidayType = res.data.data.id
        this.checkIfChileanAndRequestHolidays(
          res.data.data,
          hasChileanHolidayModel
        )
        this.disableNextButton = false
        if (this.vpHolidayType === 2) {
          await this.sichernPeopleDetailsGetData()
        }
      }
    },

    async sichernPeopleDetailsGetData() {
      try {
        const response = await this.vi.getDetailedBalance()
        const balanceDetails = response.data.data
        this.sichernPeopleDetailsData = balanceDetails || []
        this.previewDaysVP =
          balanceDetails.balanceOfPeriods &&
          balanceDetails.balanceOfPeriods.length > 0 &&
          balanceDetails.balanceOfPeriods[0].previewDays
            ? balanceDetails.balanceOfPeriods[0].previewDays
            : 0
      } catch (error) {
        this.sichernPeopleDetailsData = null
      }
    },

    checkAllowsSalaryPaymentAdvance(res) {
      this.salaryPaymentAdvance = false
      this.allowsSalaryPaymentAdvance = false
      this.allowsSalaryPaymentAdvance = res.allowsSalaryPaymentAdvance
      this.mutations.addParamToRequest({ anticipatePayment: 0 })
    },
    checkIfChileanAndRequestHolidays(
      { countries, id },
      hasChileanHolidayModel
    ) {
      if (
        (countries[0].id === 8 && id === 2) ||
        (hasChileanHolidayModel && id === 2 && this.isLatam)
      ) {
        this.isChileanUserAndRequestHolidays = true
        this.legales = '1'
        this.progresivos = '3'
        this.addIdHolidayTypeToRequest()
      }
    },
    addSalaryPaymentAdvanceToRequest() {
      this.mutations.addParamToRequest({
        anticipatePayment: this.salaryPaymentAdvance ? 1 : 0
      })
    },
    addIdHolidayTypeToRequest() {
      this.mutations.addParamToRequest({ holiday_types: this.idHolidayType })
      this.idHolidayType.length > 0
        ? (this.disableNextButton = false)
        : (this.disableNextButton = true)
    },
    getTranslatedDayText(cantidad) {
      if (cantidad > 1 || cantidad === 0 || cantidad < -1) {
        return this.$t('message.licenseComponent.licenseBox.days')
      } else if (cantidad === 1 || cantidad === -1) {
        return this.$t('message.licenseComponent.licenseBox.day')
      }
      return this.$t('message.licenseComponent.licenseBox.days')
    }
  }
}
</script>

<style>
#balanceDetails > div > div > div.zt-modal-body {
  max-height: 500px;
  overflow: auto;
}

#sichernPeopleInfo > div > div > div.zt-modal-body {
  max-height: 600px;
  overflow: auto;
}

.sichern-people-table {
  width: 100%;
}

.table-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.sichern-people-table table {
  border-collapse: collapse;
  width: 100%;
  min-width: 600px;
}

.table-header-row {
  border-top: 2px solid #000;
}

.header-cell {
  padding: 12px 8px;
  text-align: center;
  font-weight: bold;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  color: #666;
  font-size: 14px;
  background-color: transparent;
  white-space: nowrap;
  min-width: 120px;
}

.header-cell:last-child {
  border-right: none;
}

.table-row:hover {
  background-color: #f8f9fa;
}

.table-cell {
  padding: 12px 8px;
  text-align: center;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  color: #333;
  font-size: 14px;
  white-space: nowrap;
  min-width: 120px;
}

.table-cell:last-child {
  border-right: none;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .table-container {
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .header-cell,
  .table-cell {
    min-width: 100px;
    padding: 8px 6px;
    font-size: 13px;
  }
}

/* Tooltip styles */
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-content {
  position: absolute;
  top: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  width: 288px;
  padding: 12px;
  background-color: #2d3748;
  color: white;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
  pointer-events: none;
}

.tooltip-container:hover .tooltip-content {
  opacity: 1;
  visibility: visible;
}

.tooltip-arrow {
  position: absolute;
  top: -5px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 10px;
  height: 10px;
  background-color: #2d3748;
}

/* Estilos para modo iframe */
.text-iframe-primary {
  color: #2694fc !important;
}

.iframe-mode {
  /* V-select colores */
  ::v-deep .v-select {
    .v-input__slot {
      &::before {
        border-color: #2694fc !important;
      }
    }
    
    &.v-input--is-focused {
      .v-input__slot::after {
        border-color: #2694fc !important;
      }
    }
    
    .v-select__selection--comma {
      color: #2694fc !important;
    }
  }
  
  /* V-checkbox colores */
  ::v-deep .v-input--checkbox {
    .v-input--selection-controls__input {
      .v-icon {
        color: #2694fc !important;
      }
    }
    
    &.v-input--is-label-active {
      .v-label {
        color: #2694fc !important;
      }
    }
  }
  
  /* Zt-check-box colores */
  ::v-deep .zt-check-box {
    .v-input--selection-controls__input {
      .v-icon {
        color: #2694fc !important;
      }
    }
  }
  
  /* Iconos */
  ::v-deep .zt-icon {
    color: #2694fc !important;
  }
  
  /* Botones */
  ::v-deep .zt-button:not([text]) {
    background-color: #2694fc !important;
    border-color: #2694fc !important;
    
    &:hover:not(:disabled) {
      background-color: #1e7fd4 !important;
      border-color: #1e7fd4 !important;
    }
  }
}
</style>
